import { View } from '@24i/nxg-sdk-quarks';
/*
 * To include Web support we could also check out this library
 * https://docs.expo.io/versions/latest/sdk/blur-view/
 */
export default View;
